const actions = {
  betSlipChecks (context, betTypeObj) {
    // console.log('betSlipChecks')
    // console.log(betTypeObj)
    return new Promise((resolve, reject) => {
      var errors = []
      var isLoggedIn = context.rootGetters['isLoggedIn']

      if (!isLoggedIn) {
        errors.push('NOT_LOGGED_IN')
      } else {
        var tnC4SB = context.rootGetters['tncState/getSBtnc']
        // console.log('tnC4SB:')
        // console.log(tnC4SB)
        if (tnC4SB.checked && tnC4SB.shouldReconfirm) {
          errors.push('RECONFIRM_TNC_SB')
        }

        /*
        var teaserSports = []
        if (betTypeObj.tab === 'TEASER') {
          for (var i in betTypeObj.selectedTeaser) {
            if (betTypeObj.selectedTeaser[i]) {
              teaserSports.push(i)
            }
          }
        }
        teaserSports.indexOf(s.idfosporttype) > -1 &&
        */
        var nonAvailableForBetting = context.state.betslipSelections.filter(function (s) {
          return (s.isclosed || !s.istradable || s.idfobolifestate === 'NR') &&
            ((betTypeObj.tab === 'REGULAR' && (betTypeObj.betTypeStakes.REGULAR.PerSelection[s.idfoselection] || betTypeObj.betTypeStakes.REGULAR.PerBetType.A)) ||
              (betTypeObj.tab === 'RR' && context.getters.isOptedIn({tab: betTypeObj.tab, id: s.idfoselection})) ||
              (betTypeObj.tab === 'TEASER' && context.getters.isOptedIn({tab: betTypeObj.tab, id: s.idfoselection})))
        }).length
        if (nonAvailableForBetting) {
          errors.push('CLOSED_or_SUSPENDED')
        }

        var noBetTypes = !betTypeObj.id.length
        if (noBetTypes) {
          errors.push('NO_BET_TYPES')
        }

        if (betTypeObj.tab === 'TEASER' && !context.getters.allowInPlayTeasers) {
          var liveSelections = context.getters.liveSelections
          var notAvailableForBetting = context.state.betslipSelections.filter(function (s) {
            return context.getters.isOptedIn({tab: betTypeObj.tab, id: s.idfoselection}) && liveSelections.indexOf(s.idfoselection) > -1
          }).length
          if (notAvailableForBetting) {
            errors.push('NO_LIVE_TEASERS_ALLOWED')
          }
        }

        if (betTypeObj.noStakes) {
          errors.push('NO_STAKES')
        }

        if (betTypeObj.minValuesNotMet) {
          errors.push('HAS_ERRORS')
          errors.push('MIN_STAKE')
        }
        if (betTypeObj.maxValuesNotMet) {
          errors.push('HAS_ERRORS')
          errors.push('MAX_STAKE')
        }
        if (betTypeObj.minReturnNotMet) {
          // errors.push('HAS_ERRORS')
          // errors.push('MIN_RETURN')
        }
        //
        var totalStake = betTypeObj.betTypeStakes.PerTab[betTypeObj.tab] * 1
        var slipTotalStakeMin = context.getters.slipTotalStakeMin
        if (slipTotalStakeMin && totalStake < slipTotalStakeMin) {
          errors.push('SLIP_TOTALSTAKE_MIN')
        }
        var isLive = !!context.getters.liveSelections.length
        if (isLive) {
          var slipTotalStakeMaxInPlay = context.getters.slipTotalStakeMaxInPlay
          if (slipTotalStakeMaxInPlay && totalStake > slipTotalStakeMaxInPlay) {
            errors.push('SLIP_TOTALSTAKE_MAX_INPLAY')
          }
        } else {
          var slipTotalStakeMax = context.getters.slipTotalStakeMax
          if (slipTotalStakeMax && totalStake > slipTotalStakeMax) {
            errors.push('SLIP_TOTALSTAKE_MAX')
          }
        }
        var maxTakeOut = context.getters.maxTakeOut
        if (maxTakeOut) {
          var winnings = context.getters.returns
          var winning = winnings && winnings.PerTab && winnings.PerTab[betTypeObj.tab] && winnings.PerTab[betTypeObj.tab] * 1
          if (winning > maxTakeOut) {
            errors.push('MAX_TAKEOUT')
          }
        }
        //

        var tradingBalance = context.rootGetters['sbBetslipState/tradingBalance']
        if (tradingBalance === 0 || 1 * betTypeObj.betTypeStakes.PerTab[betTypeObj.tab] > tradingBalance) {
          errors.push('INSUFFICIENT_FUNDS')
        }
      }
      if (errors.length) {
        console.log('betSlipChecks errors:')
        console.log(errors)
        reject(errors)
      } else {
        resolve(true)
      }
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/sports/betslip/actions/betSlipChecks.js